module.exports = __webpack_public_path__ + "img/tutorial_BG_fahrrad.f1484082.jpg";